import * as React from 'react'
import {Component, ReactElement} from 'react'
import {
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    DialogActions,
    Button,
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import styled from 'styled-components'
import {Colors, FontFamily, FontSize, FontWeights} from '../../styledComponents/Constants'
import {createIconWithLevel} from '../../styledComponents/adminPage/IconCreator'
import {FullWidthLeftRowFlexContainer, LeftRowFlexContainer} from '../../styledComponents/FlexComponents'
import {MESSAGE_TYPE} from '../../CodeMaster'
import {Nullable} from '../../app/TypeHelpers'
import {UnstyledLinkStyledButton} from '../../styledComponents/Button'
import {HideInPC, HideInSP} from '../../styledComponents/ResponsiveConvenience'

export interface DialogButtonParams {
    buttonLabel: string
    buttonHandler: (...params: any) => void
    isDefault: boolean
}

export interface DialogParams {
    title: string
    errorLevel: MESSAGE_TYPE
    message: string
    buttonProps: DialogButtonParams[]
}

interface Props {
    params: Nullable<DialogParams>
    open: boolean
}

// TODO NatResidentMessageDialogComponentと同じ機能になったので使用箇所変更後に削除予定
// TODO 以降はNatResidentMessageDialogComponentを使用すること
export default class MessageDialogComponent extends Component<Props> {

    constructor(props: Props) {
        super(props)
    }

    render(): Nullable<ReactElement> {
        if (!this.props.params) {
            return null
        }

        return (
            <>
                <HideInSP>
                    <Dialog
                        open={this.props.open}
                        aria-labelledby="dialog-title"
                        aria-describedby="dialog-description"
                        transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                    >
                        <PCDialogTitle id="dialog-title">
                            <BoldLeftRowFlexContainer>
                                {createIconWithLevel(this.props.params.errorLevel)}{this.props.params.title}
                            </BoldLeftRowFlexContainer>
                        </PCDialogTitle>
                        <PCDialogContent>
                            <PCDialogContentText id="dialog-description">
                                {this.props.params.message}
                            </PCDialogContentText>
                        </PCDialogContent>
                        <DialogActions>
                            {
                                this.props.params.buttonProps.map((buttonProp, index) => (
                                    <PCDialogButton
                                        key={index}
                                        color="primary"
                                        onClick={buttonProp.buttonHandler}
                                    >
                                        {buttonProp.buttonLabel}
                                    </PCDialogButton>
                                ))
                            }
                        </DialogActions>
                    </Dialog>
                </HideInSP>
                <HideInPC>
                    <SPMessageDialog
                        open={this.props.open}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                    >
                        <SPDialogTitle id="alert-dialog-title">
                            {createIconWithLevel(this.props.params.errorLevel)}{this.props.params.title}
                        </SPDialogTitle>
                        <SPDialogContent>
                            <SPDialogContentText id="alert-dialog-description">
                                {this.props.params.message}
                            </SPDialogContentText>
                        </SPDialogContent>
                        <SPDialogActions>
                            <FullWidthLeftRowFlexContainer>
                                {
                                    this.props.params.buttonProps.map((buttonProp, index) => (
                                        <SPDialogActionButton
                                            key={index}
                                            onClick={buttonProp.buttonHandler}
                                        >
                                            {buttonProp.buttonLabel}
                                        </SPDialogActionButton>
                                    ))
                                }
                            </FullWidthLeftRowFlexContainer>
                        </SPDialogActions>
                    </SPMessageDialog>
                </HideInPC>
            </>
        )
    }
}

const SPMessageDialog = withStyles({
    paper: {
        maxWidth: '420px',
        minWidth: '290px',
    },
})(Dialog)

const PCDialogTitle = styled(DialogTitle)`
  &.MuiDialogTitle-root.MuiTypography-root {
    font-size: ${FontSize.Big};
    font-weight: bold;
  }
`

const PCDialogContent = styled(DialogContent)`
  &.MuiDialogContent-root {
    overflow-y: visible;
  }
`

const PCDialogContentText = styled(DialogContentText)`
  &.MuiDialogContentText-root {
    font-size: ${FontSize.Body};
    white-space: pre-line;
  }
`

const PCDialogButton = styled(Button)`
  &.MuiButton-text {
    font-size: ${FontSize.Body};
  }
`

const BoldLeftRowFlexContainer = styled(LeftRowFlexContainer)`
  font-weight: ${FontWeights.Bold};

  svg {
    font-size: ${FontSize.ExtraBig};
    margin-right: 2px;
  }
`

const SPDialogActions = styled(DialogActions)`
  &.MuiDialogActions-root {
    padding: 0;
  }
`

const SPDialogTitle = styled(DialogTitle)`
  &.MuiDialogTitle-root.MuiTypography-h6 {
    padding: 15px 15px 0 15px;
    color: ${Colors.Body};
    font-size: 16px;
    font-family: ${FontFamily.ResidentDefault};
    display: flex;
    align-items: center;
  }

  &.MuiTypography-h6 svg {
    font-size: 20px;
    margin-right: 10px;
  }
`

const SPDialogContent = styled(DialogContent)`
  &.MuiDialogContent-root {
    padding: 10px 15px 20px 15px;
  }

  & .MuiTypography-root {
    color: ${Colors.Body};
    font-size: 14px;
    font-family: ${FontFamily.ResidentDefault};
  }
`

const SPDialogContentText = styled(DialogContentText)`
  &.MuiDialogContentText-root {
    white-space: pre-line;
  }
`

const SPDialogActionButton = styled(UnstyledLinkStyledButton)`
  margin: 0;
  padding: 10px 10px 15px;
  width: 100%;
  border-top: ${Colors.AccentLight} solid 1px;
  white-space: nowrap;
  color: ${Colors.Primary};

  &:not(:last-child) {
    border-right: ${Colors.AccentLight} solid 1px;
  }
`
